module.exports = "## PNG compressor\r\n\r\nPNG compresses images while keeping original data (lossless). As a result, file size can be bigger. Our compressor applies lossy algorithms, strip unwanted data, converts 24-bit color index to 8-bit. The Result is a drastically lower PNG image size with the same image quality."


//////////////////
// WEBPACK FOOTER
// ./src/containers/CompressImages/png-compressor.md
// module id = 1143
// module chunks = 0